import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Pool actuellement sélectionné par l'utilisateur dans le dashboard.
 * Persisté en sessionStorage. Toujours revalidé côté serveur (les RPC vérifient
 * `dashboardadmin` d'elles-mêmes), ce store est purement une préférence UI.
 */
interface CiPoolState {
  selectedLeagueId: number | null;
  setSelectedLeagueId: (id: number | null) => void;
}

export const useCiPoolStore = create<CiPoolState>()(
  persist(
    (set) => ({
      selectedLeagueId: null,
      setSelectedLeagueId: (id) => set({ selectedLeagueId: id }),
    }),
    {
      name: 'ci-dashboard-pool',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
